import { createAction } from '@mendeley-internal/lib-js-redux-actions';

export const awaitPendingAction = createAction('AWAIT_PENDING_ACTION');

export const clearPendingAction = createAction('CLEAR_PENDING_ACTION');



// WEBPACK FOOTER //
// ./src/universal/ui/actions/pending.js